module.exports = __webpack_public_path__ + "img/wallet-header.c994d3a0.svg";